// Plain animated-pulse div for loading placeholders (skeleton fill, design
// value collapsed onto --muted per the design-to-token mapping §2.3).
import { cn } from "./lib/utils";

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("animate-pulse rounded-md bg-muted", className)} {...props} />;
}

export { Skeleton };
